/**
 * Role-aware URL path helpers for the MCP Reminder API.
 * Shared by queries and mutations to avoid duplicating path construction.
 */

import { canUseAdminTenantScope } from '@/utils/authz';

/** Gateway base path for the MCP Reminder service. */
const BASE_URL = '/mcp-reminder/api';

/**
 * Role-aware base path for reminder endpoints.
 * - ADMIN: `/mcp-reminder/api/reminder/admin`
 * - CLIENT: `/mcp-reminder/api/reminder`
 *
 * @param role - Current user role
 * @returns Base URL for reminder API calls
 */
export const roleReminderBase = (role?: string): string => {
  if (canUseAdminTenantScope(role)) return `${BASE_URL}/reminder/admin`;
  return `${BASE_URL}/reminder`;
};
